var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"foot"},[(this.$route.meta&&this.$route.meta=='home')?_c('BottomBar'):_vm._e(),_c('div',{staticClass:"main"},[_c('span',{staticClass:"txt"},[_vm._v("  Copyright © 2018~"+_vm._s(_vm.currentYear)+" "+_vm._s(_vm.$t('copyright')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }